import { render, staticRenderFns } from "./UploadedFileStatus.vue?vue&type=template&id=c80401ee&scoped=true&"
import script from "./UploadedFileStatus.vue?vue&type=script&lang=js&"
export * from "./UploadedFileStatus.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileStatus.vue?vue&type=style&index=0&id=c80401ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80401ee",
  null
  
)

export default component.exports